// Query-key factory for the tenant Test Mode toggle. Kept separate from the
// other settings caches so switching mode only refetches the mode.
export const modeKeys = {
  all: ['tenant-mode'] as const,
  detail: (tenantId: string) => [...modeKeys.all, tenantId] as const,
};
